import { Component, OnInit } from '@angular/core';
import { SessionStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppService } from '../../app.service';
import { MsalService } from "@azure/msal-angular";
@Component({
  selector: 'app-employee-dashboard',
  templateUrl: './employee-dashboard.component.html',
  styleUrls: ['./employee-dashboard.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)',

      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ]
})
export class EmployeeDashboardComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  menuState: any = 'out';
  public navigations: any = [];
  public isDelegated: boolean = false;
  public currentYear;
  constructor(private router: Router, private appService: AppService,private authService: MsalService) { }

  ngOnInit() {
    const d = new Date();
    this.currentYear = d.getFullYear();
    this.navigations = [
      { title: 'Dashboard', link: '/employee/dashboard' },
      { title: 'Timesheet Entry', link: '/employee/timesheet-entry' },
      { title: 'Notifications', link: '/employee/notification' },
      { title: 'Projects', link: '/employee/project' }
    ];
    if (this.user.delegation && this.user.delegation.isDelegated == true) {
      this.navigations.push({ title: 'Timesheet Approvals', link: '/employee/timesheet-approval' });
    }

    if (this.config.businessUnit === 'accenture') {
      this.navigations.push(
        { title: 'Approval List', link: '/employee/timeSheetApprovalsList' });
    } else if (this.config.businessUnit === 'ipdo' || this.config.businessUnit === 'biologics' || this.config.businessUnit === 'chinateam' || this.config.businessUnit == 'aps') {
      this.navigations.push(
      { title: 'Rejected List', link: '/employee/timeSheetRejectedList' });
    }
  }

  /**Function to logout from the application*/
  logOut() {
    // this.appService.logOut().subscribe((res) => {
    //   this.router.navigate(['/']);
    // },
    //   (error) => {
    //     this.router.navigate(['/']);
    //   });
    this.authService.logout();
    this.appService.logOut();
  } 

  /**Function hide/visible nav tab toggle*/
  hideSideNavIfOpen(e) {
    if (this.menuState === 'in') {
      if (e.toElement.className == 'navbar-toggle collapsed open-right-sidebar') {
      } else {
        this.menuState = this.menuState === 'out' ? 'in' : 'out';
      }
    }
  }

  /**Function to toggle*/
  toggleMenu() {
    this.menuState = 'in';
  }
}



// WEBPACK FOOTER //
// ./src/app/common/employee-dashboard/employee-dashboard.component.ts